import React from "react";
import "./EmsFeeReceiptDocument.css";

function EmsFeeReceiptDocument({ data }) {
  if (!data) return null;

  return (
    <div className="ems-fee-receipt" id="ems-fee-receipt-document">
      <div className="ems-fee-receipt__header">
        {data.logoUrl ? (
          <div className="ems-fee-receipt__logo-wrap">
            <img
              src={data.logoUrl}
              alt={data.organizationName || "Organization logo"}
              className="ems-fee-receipt__logo"
              crossOrigin="anonymous"
            />
          </div>
        ) : null}
        <div className="ems-fee-receipt__org-block">
          {data.organizationName && data.organizationName !== "—" ? (
            <div className="ems-fee-receipt__org-name">{data.organizationName}</div>
          ) : null}
          <div className="ems-fee-receipt__contact">
            <div className="ems-fee-receipt__contact-item">
              <strong>Phone:</strong> {data.phone}
            </div>
            <div className="ems-fee-receipt__contact-item">
              <strong>Email:</strong> {data.email}
            </div>
            <div className="ems-fee-receipt__contact-item">
              <strong>Website:</strong> {data.website}
            </div>
          </div>
        </div>
      </div>

      <hr className="ems-fee-receipt__rule" />

      <div className="ems-fee-receipt__title">Fee Receipt</div>
      <div className="ems-fee-receipt__copy-title">Student Copy</div>

      <hr className="ems-fee-receipt__rule" />

      <div className="ems-fee-receipt__details">
        <div className="ems-fee-receipt__details-col">
          <div className="ems-fee-receipt__field">
            <span className="ems-fee-receipt__label">Receipt No.</span>
            <span className="ems-fee-receipt__value">{data.receiptNo}</span>
          </div>
          <div className="ems-fee-receipt__field">
            <span className="ems-fee-receipt__label">Receipt Date</span>
            <span className="ems-fee-receipt__value">{data.receiptDate}</span>
          </div>
          <div className="ems-fee-receipt__field">
            <span className="ems-fee-receipt__label">Financial Year</span>
            <span className="ems-fee-receipt__value">{data.financialYear}</span>
          </div>
        </div>
        <div className="ems-fee-receipt__details-col">
          <div className="ems-fee-receipt__field">
            <span className="ems-fee-receipt__label">Student Name</span>
            <span className="ems-fee-receipt__value">{data.studentName}</span>
          </div>
          <div className="ems-fee-receipt__field">
            <span className="ems-fee-receipt__label">Student ID</span>
            <span className="ems-fee-receipt__value">{data.studentId}</span>
          </div>
          <div className="ems-fee-receipt__field">
            <span className="ems-fee-receipt__label">Admission No.</span>
            <span className="ems-fee-receipt__value">{data.admissionNo}</span>
          </div>
        </div>
      </div>

      <div className="ems-fee-receipt__fee-summary">
        <div className="ems-fee-receipt__fee-line">
          <span className="ems-fee-receipt__fee-particular">{data.particulars}</span>
          <span className="ems-fee-receipt__fee-amount">{data.amountFormatted}</span>
        </div>

        <div className="ems-fee-receipt__fee-total">
          <span className="ems-fee-receipt__fee-total-label">Received</span>
          <span className="ems-fee-receipt__fee-total-amount">
            {data.amountFormatted}
          </span>
        </div>
      </div>

      <div className="ems-fee-receipt__meta">
        <div className="ems-fee-receipt__meta-row">
          <strong>In words:</strong> {data.amountInWords}
        </div>
        <div className="ems-fee-receipt__meta-row">
          <strong>Payment Mode:</strong> {data.paymentMode}
        </div>
        <div className="ems-fee-receipt__meta-row">
          <strong>Payment Status:</strong> {data.paymentStatus}
        </div>
      </div>

      <div className="ems-fee-receipt__footer">{data.footerNote}</div>
      <div className="ems-fee-receipt__page">{data.pageLabel}</div>
    </div>
  );
}

export default EmsFeeReceiptDocument;
